export default __webpack_public_path__ + "img/accha/accha3_700.jpg";